import * as Html from "../../util/Html.ts";
import * as forms from "../../util/forms.js";
import * as i18n from "../../i18n.ts";
import ApiServer from "../../ApiServer.js";

export {init}
Html.registerWidget('widget/form/validator',{init:init})

var  
  VALIDATOR_ATTRIBUTE = "data-fw-form-validator",

  // Name of data- attribute for error message of required control
  REQUIRED_CONTROL_ERROR_ATTRIBUTE = "data-fw-form-required-error",

  EMAIL_REGEX = /^[\-a-z0-9~!$%\^&*_=+}{\'?]+(\.[\-a-z0-9~!$%\^&*_=+}{\'?]*)*@([a-z0-9_][\-a-z0-9_]*(\.[\-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,

  validator = {
    email:function(){
      var 
        input = this,
        val =input.val().trim();
      input.val(val);
      if(!EMAIL_REGEX.test(val)){
        throw new Error(i18n.get("errors.emailInvalid"));
      }
      return true;
    },
    emailidentifier:function(){
      var 
        input = this,
        val = input.val().trim(),
        isSubmitRunning = (input.parents('form').attr('data-submit-running')==='true');
      //reput trimmed value
      input.val(val);
      //check its a mail
      if(!EMAIL_REGEX.test(val)){
        throw new Error(i18n.get("errors.emailInvalid"));
      }
      //if it has just been verified it's ok
      if(val===input.data('valid-value')){
        return true;
      }
      //check it is a free identifier
      ApiServer.log2check(null,val,function(isAvailable){
        if (!isAvailable){
          forms.markInvalid(input, i18n.get("errors.emailUnavaible"));
        }else{
          forms.markValid(input);
          //store valid value
          input.data('valid-value',val);
          //we interuppted submit by this validation, so we resubmit
          if(isSubmitRunning){
            input.parents('form').trigger('submit');
          }
        }
      },function(error){
        forms.markInvalid(input, i18n.get("invitationJs.errorEmail") );
      });
      //invalid while it is not checked
      return false;
    },
    loginidentifier:function(){
      var 
        input = this,
        val = input.val().trim();
      if(val.indexOf('@')>-1){
        throw new Error(i18n.get("errors.identifierInvalid"));
      }
      return true;
    },
    minsize:function(size,errorkey){
      if(this.val().length<size){
        throw new Error(i18n.get(errorkey));
      }
      return true;
    },
    daterequired:function(){
      if(!this.prop('disabled')){
        if(this.val()===''||this.val()==='$empty'){
          throw new Error(this.attr("data-fw-form-required-error")||i18n.get("fw2.fields.requiredError",this.attr("placeholder")));
        }
      }
      return true;
    },
    identifier:function(){
      this.val(this.val().trim());
      if(forms.isEmpty(this)){
        throw new Error(this.attr(REQUIRED_CONTROL_ERROR_ATTRIBUTE)||i18n.get("fw2.fields.requiredError",this.attr("placeholder")));
      }
      return true;
    },
    password:function(){
      this.val(this.val().trim());
      if(this.val().length<8){
        throw new Error(i18n.get("errors.passwordTooShort"))
      }
      return true;
    },
    passwordConfirm:function(passName){
      this.val(this.val().trim());
      if(this.val() === this.get(0).form[passName].value){
        return true;
      }else{
        throw new Error(i18n.get("formUserPasswordChange.errorConfirm"))
      }
    },
    required(){
      return !forms.isEmpty(this)
    },
    requiredifempty:function(otherfield){
      var i;
      if(!forms.isEmpty(this)){
        return true;
      }
      for(i=0;i<arguments.length;i++){
        if(!forms.isEmpty($(this.get(0).form[arguments[i]]))){
          return true;
        }
      }
      return false;
      
    },
    confirmEquals:function(passName){
      return this.val() === this.get(0).form[passName].value;
    },
    birthdateconfirm:function(){
      if(this.val()==='' || this.val()==='$empty'){
        throw new Error('Birthday is missing');
      }
      if(!/^\d\d\d\d-\d\d-\d\d/g.test(this.val())){
        throw new Error('Invalid date, use yyyy-mm-dd');
      }
      var thirteenYearsAgo = new Date();
      thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear()-13);
      
      return new Date(this.val())<thirteenYearsAgo;
    }
  };
  
function init(input){
  if(input.attr(VALIDATOR_ATTRIBUTE)){
    var
      validatorAttr = input.attr(VALIDATOR_ATTRIBUTE),
      validatorCall = validatorAttr.split(':'),
      validatorFunc = validator[validatorCall[0]],
      validatorArgs = validatorCall.splice(1);

    forms.checkInput(
      input,
      function(input){
        return validatorFunc.apply(input,validatorArgs);
      },
      i18n.get(input.attr("data-fw-form-validator-error")||"")
    );  
  }
}
  